const useCssSpecialClasses = () => {
  const cssSpecialClasses = {
    // Avoid text to overflow containers
    '.text-ellipsis': {
      maxWidth: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },

    // Minimize input file DOM presence
    '.hidden': {
      position: 'absolute',
      visibility: 'hidden', // hide input
      height: '1px', // minimize DOM presence
      width: '1px' // minimize DOM presence
    },

    // Common props for line-clamp
    '[class*= "text-line-clamp-"]': {
      overflow: 'hidden',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical'
    },

    // Limit text to 1 line with ellipsis
    '.text-line-clamp-1': {
      lineClamp: '1',
      WebkitLineClamp: '1'
    },

    // Limit text to 2 lines with ellipsis
    '.text-line-clamp-2': {
      lineClamp: '2',
      WebkitLineClamp: '2'
    },

    // Limit text to 3 lines with ellipsis
    '.text-line-clamp-3': {
      lineClamp: '3',
      WebkitLineClamp: '3'
    },

    // Lazy Load Img
    '.blur-up': {
      WebkitFilter: 'blur(5px)',
      filter: 'blur(5px)',
      transition: 'filter 400ms, -webkit-filter 400ms'
    },
    '.blur-up.lazyloaded ': {
      WebkitFilter: 'blur(0)',
      filter: 'blur(0)'
    }
  };

  return { cssSpecialClasses };
};

export default useCssSpecialClasses;
